import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
export var useGlobalMethods = function () {
    var navigate = useNavigate();
    useEffect(function () {
        window.navigateWithRouter = function (element, event) {
            if (event) {
                event.preventDefault();
            }
            var path = element.getAttribute('href');
            if (path) {
                navigate(path, {
                    state: {
                        backUrl: window.location.pathname + window.location.search
                    }
                });
            }
        };
    }, [navigate]);
};
export default useGlobalMethods;
